import React, { useMemo } from 'react';
import Select from '../../ui/PortalSelect';
import { Alert } from '@mui/material';
import { getPortalSelectProps } from '../../ui/selectPresentation';
import './UserAccountAllocation.css';

export default function UserAccountAllocation({
  accounts,
  homeAccountId,
  role,
  allocatedAccountIds,
  onChange,
  disabled = false,
}) {
  const accountScope = role?.account_scope || 'Permission based';
  const options = useMemo(() => (accounts || []).map((account) => ({
    value: String(account._id),
    label: `${account.company_name} (${account._id})`,
  })), [accounts]);
  const normalizedAllocated = useMemo(() => {
    const values = new Set((allocatedAccountIds || []).map(String));
    if (homeAccountId) values.add(String(homeAccountId));
    return Array.from(values);
  }, [allocatedAccountIds, homeAccountId]);
  const selectedOptions = options.filter((option) => normalizedAllocated.includes(option.value));

  if (!role) return null;

  if (accountScope !== 'Selected accounts') {
    return (
      <Alert severity="info" className="mb-3">
        Account scope for this role: <strong>{accountScope}</strong>.
        {accountScope === 'All accounts' && ' This user will be able to select every active account.'}
        {accountScope === 'Own Corporate + Affiliates' && ' Linked affiliates are resolved automatically.'}
      </Alert>
    );
  }

  return (
    <div className="user-account-allocation row mb-3 align-items-start">
      <div className="col-12 col-md-2">
        <label htmlFor="account_allocated" className="form-label">Allocated accounts</label>
      </div>
      <div className="user-account-allocation__field col-12 col-md-7">
        <Select
          {...getPortalSelectProps()}
          className="user-account-allocation-select"
          classNamePrefix="user-account-allocation-select"
          inputId="account_allocated"
          isMulti
          isDisabled={disabled}
          options={options}
          value={selectedOptions}
          closeMenuOnSelect={false}
          onChange={(selected) => {
            const nextValues = (selected || []).map((option) => option.value);
            if (homeAccountId && !nextValues.includes(String(homeAccountId))) {
              nextValues.unshift(String(homeAccountId));
            }
            onChange(nextValues);
          }}
          placeholder="Select accounts"
        />
        <small className="user-account-allocation__hint text-muted">
          The user&apos;s home account is always included.
        </small>
      </div>
    </div>
  );
}
